import React from 'react';

import { Tooltip } from 'antd';

import Tag from 'components/Tag';
import { enums } from 'helpers/enums';
import { resolveProductStatus } from 'helpers/functions';
import type { EModerationStatus } from 'v2/interfaces/product';

type ProductStatusTagProps = {
  status: EModerationStatus;
  productType: number;
};

export default function ProductStatusTag({ status, productType }: ProductStatusTagProps) {
  const statusCode = resolveProductStatus(status, productType);
  const productStatus = enums.PRODUCT_STATUS[statusCode];

  return (
    <Tooltip title={productStatus.description}>
      <div>
        <Tag label={productStatus.label} status={productStatus.status} />
      </div>
    </Tooltip>
  );
}
